import "@openreply/pattern-library/styles";

import { createApp, h } from "vue";

import { plugin, translator } from "~/intl/plugin";
import { widgetConfig } from "~/plugins/configuration";
import { Version } from "~/services/version";
import { Logger } from "~/utils/logger";

import App from "./App.vue";

const componentName = widgetConfig.customElement || "";

const app = createApp({
  render: () => h(App),
});

class HeyObiCareCalendarWidgetApp extends HTMLElement {
  connectedCallback() {
    const mountPoint = document.querySelector(componentName);
    if (mountPoint) {
      app.provide("translator", translator);
      app.use(plugin);

      app.mount(mountPoint);

      const version = new Version();
      this.dataset.version = version.commitTimeStamp();
      Logger.logInfo(`${componentName} version: ${version.commitTimeStamp()}`);
    } else {
      Logger.logError(`${componentName}: Mount point not found`);
    }
  }
}

window.customElements.define(componentName, HeyObiCareCalendarWidgetApp);
